export default __webpack_public_path__ + "static/media/itchbook-pink-16px.709160f6.svg";